Vue.component('vacation-ld-json', {
    props: ['vacation'],
    computed: {
        ldJsonHtml: function () {
            var v = this.vacation;
            var html = [];

            html.push('<script type="application/ld+json">');
            html.push('{');
            html.push('    "@context": "http://schema.org/",');
            html.push('    "@type": "Product",');
            html.push('    "name": "'); html.push(v.name); html.push('",');
            html.push('    "image": "'); html.push(window.location.origin); html.push(v.image.cropUrl); html.push('",');
            html.push('    "description": "'); html.push(v.description); html.push('",');
            html.push('    "url": "'); html.push(window.location.origin); html.push(v.url); html.push('",');
            html.push('    "brand": {');
            html.push('        "@type": "Thing",');
            html.push('        "name": "Grand European Travel"');
            html.push('    }');
            if (v.reviews && v.reviews.value && v.reviews.value.totalReviews) {
                var rating = '' + v.reviews.value.averageRating;
                if (!/\./.test(rating)) rating += '.0';
                rating = rating.replace(/^.*([0-9]\.[0-9]).$/, '$1');

                html.push('    ,"aggregateRating": {');
                html.push('        "@type": "AggregateRating",');
                html.push('        "bestRating": "5",');
                html.push('        "worstRating": "1",');
                html.push('        "ratingValue": "'); html.push(rating); html.push('",');
                html.push('        "reviewCount": "'); html.push(v.reviews.value.totalReviews); html.push('"');
                html.push('    }');
            }
            if (v.lowPrice && v.highPrice) {
                html.push('    ,"offers": {');
                html.push('        "@type": "AggregateOffer",');
                html.push('        "priceCurrency": "USD",');
                html.push('        "lowPrice": "'); html.push(v.lowPrice); html.push('",');
                html.push('        "highPrice": "'); html.push(v.highPrice); html.push('"');
                html.push('    }');
            }
            if (v.featuredReviewTitle && v.featuredReviewTitle.length && v.featuredReviewAuthor && v.featuredReviewAuthor.length) {
                html.push('    ,"review": [{');
                html.push('        "@type": "Review",');
                html.push('        "author": "'); html.push(v.featuredReviewAuthor); html.push('",');
                html.push('        "description": "'); html.push(v.featuredReviewQuote); html.push('",');
                html.push('        "name": "'); html.push(v.featuredReviewTitle); html.push('",');
                html.push('        "reviewRating": {');
                html.push('            "@type": "Rating",');
                html.push('            "bestRating": "5",');
                html.push('            "worstRating": "1",');
                html.push('            "ratingValue": "5"');
                html.push('        }');
                html.push('    }]');
            }
            html.push('}');
            html.push('</script>');

            return html.join('');
        }
    },
    template: '<div class="ld-json" v-html="ldJsonHtml"></div>'
});